/* eslint-disable jsdoc/check-types -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-returns -- Introduced in TP-9489. */
/* eslint-disable jsdoc/tag-lines -- Introduced in TP-9489. */

/**
 * Checks if the banner should stick to the bottom of its container
 * @param {Node} element - banner
 * @param {Node} container
 * @param {Number} scrollPosition
 */
const scrolledToBottom = (element, container, scrollPosition) => {
	const containerPadding = 35;
	const bottomScrollPosition = scrollPosition + window.innerHeight;
	const containerBottomPosition = container.offsetTop + container.offsetHeight;

	const elementBottomPosition =
		bottomScrollPosition -
		(window.innerHeight - element.offsetHeight) +
		containerPadding;

	return elementBottomPosition >= containerBottomPosition;
};

/**
 * Sets one specified utility class on element and removes others
 * @param {Node} element to set class on
 * @param {String} className to set
 */
const setUtility = (element, className) => {
	const toRemove = ['_sticky', '_bottomFixed'].filter((el) => el !== className);

	toRemove.forEach((classToRemove) => {
		if (element.classList.contains(classToRemove)) {
			element.classList.remove(classToRemove);
		}

		if (className) {
			element.classList.add(className);
		}
	});
};

/**
 * Makes element sticky on scroll and bound by its container element
 * @param {Node} element
 */
const setSticky = (element) => {
	let lastOffset = null;

	window.addEventListener('scroll', () => {
		const scrollPosition =
			(document.documentElement && document.documentElement.scrollTop) ||
			document.body.scrollTop;

		const bannerOffset = scrollPosition + element.getBoundingClientRect().top;

		const fixToBottom = scrolledToBottom(
			element,
			document.querySelector('.Exp-sidebar'),
			scrollPosition,
		);

		const shouldBeSticky =
			scrollPosition >= (lastOffset || bannerOffset) && !fixToBottom;

		if (!element.classList.contains('_sticky') && shouldBeSticky) {
			if (!element.classList.contains('_bottomFixed')) {
				lastOffset = bannerOffset;
			}

			setUtility(element, '_sticky');
		} else if (!element.classList.contains('_bottomFixed') && fixToBottom) {
			setUtility(element, '_bottomFixed');
		} else if (scrollPosition < lastOffset) {
			setUtility(element, null);
		}
	});
};

export default setSticky;
